import(/* webpackMode: "eager" */ "/app/new-design/pale-blue-dot-redesign/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["PolicyShareButton"] */ "/app/new-design/pale-blue-dot-redesign/src/components/policy/PolicyShareButton.tsx");
